import { PaymentMethod } from '../common/constants'
import { PriceOptions } from './bookingFormTypes'

export const enum LocationTypes {
  DaNang = 1,
  QuyNhon = 2,
}

export interface IHotelInfo {
  hotelId: number
  phoneNumber: string
  address: string
  hotelName: string
  location: string
  locationId: number
  imageUrl: string
  rooms: IRoomInfo[]
  defaultHours?: number
  isActive?: boolean
  webPaymentServiceId?: string
}

export interface IRoomInfo {
  roomTypeName: string
  roomTypeId: number
  roomImages: string[]
  roomDescription: string
}

export interface IHotelAvailability {
  AvailableRooms: number
  RoomTypeId: number
  RoomPriceId: number
  TotalPrice: number
  TotalOriginalPrice?: number
  PriceUnit: number
  Quantity: number
}

export interface ISearchAvailabilityQuery {
  from: string
  to: string
  priceOption: PriceOptions
}

export interface ICreateBookingRequest {
  from: string
  to: string
  roomPriceId: number
  roomTypeId: number
  priceOption: PriceOptions
  contactName: string
  phoneNumber: string
  note?: string
  emailInfo?: {
    priceInfo: IHotelAvailability
  }
  paymentMethod?: PaymentMethod
}

export interface ICreateBookingResponse {
  Id: number
  // ReservationId: number
  ArrivalDate: string
  DepartureDate: string
}

export interface IHotelReservationInfo {
  Fullname: string
  Mobile: string
  HotelId: number
  ArrivalDate: string
  DepartureDate: string
  Note: string
  /**
   * This is the reservation id in url
   */
  ReservationRoomId: number
  /**
   * This is the actual booking reservation number
   */
  ReservationNumber: number
  RoomTypeId: number
  RoomTypeName: string
  RoomId?: number
  RoomName?: string
  TotalPrice: number
  PriceOption: PriceOptions
  IsTaxApplied: boolean
  BookingStatus: BookingStatus
  PaymentStatus: PaymentStatus
  PaymentMethod: PaymentMethod
}

export const enum PaymentStatus {
  NotPaid = 0,
  Paid = 1,
  Error = 2,
}

export const enum BookingStatus {
  BOOKED = 'BOOKED',
  CHECKIN = 'CHECKIN',
  CHECKOUT = 'CHECKOUT',
  CANCELLED = 'CANCELLED',
}
